'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var objectWithoutProperties = require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../NuDSProvider/NuDSProvider.js');
require('../../slicedToArray-a8a77f0e.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
var components_Icon_Icon = require('../../Icon-efcd1bee.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
var components_Typography_Typography = require('../Typography/Typography.js');
var formik_esm = require('../../formik.esm-e131ccca.js');
require('../../utils/string/isString.js');
var validateField = require('../../validateField-372afc12.js');
var components_FieldErrorMessage_FieldErrorMessage = require('../FieldErrorMessage/FieldErrorMessage.js');
var FormContext = require('../../FormContext-74eaf8f0.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Label = styled__default['default'].label.withConfig({
  displayName: "Label",
  componentId: "sc-1fevho4-0"
})(["cursor:pointer;position:relative;display:block;color:", ";"], styles_themeUtils.nuDSColor('black', 'defaultT70'));
Label.displayName = 'Label';
var LabelText = styled__default['default'].div.withConfig({
  displayName: "Label__LabelText",
  componentId: "sc-1fevho4-1"
})([""]);
LabelText.displayName = 'LabelText';

var floatingLabelCSS = styled.css(["transform:scale(.84) translateY(-25px);"]);

var validationColor = function validationColor() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$defaultColorName = _ref.defaultColorName,
      defaultColorName = _ref$defaultColorName === void 0 ? 'black' : _ref$defaultColorName,
      _ref$colorVariation = _ref.colorVariation,
      colorVariation = _ref$colorVariation === void 0 ? 'default' : _ref$colorVariation;

  return function (_ref2) {
    var touched = _ref2.touched,
        hasError = _ref2.hasError,
        hasValidation = _ref2.hasValidation;

    if (!touched || !hasValidation) {
      return styles_themeUtils.nuDSColor(defaultColorName, colorVariation);
    }

    if (hasError) {
      return styles_themeUtils.nuDSColor('error');
    }

    return styles_themeUtils.nuDSColor('success');
  };
};

var validationBorderOnInteraction = function validationBorderOnInteraction(_ref3) {
  var touched = _ref3.touched,
      hasValidation = _ref3.hasValidation;
  return (!hasValidation || !touched) && styled.css(["border-bottom-color:", ";"], styles_themeUtils.nuDSColor('black'));
};

var Input = styled__default['default'](components_Typography_Typography['default']).withConfig({
  displayName: "Input",
  componentId: "sc-1s2hy29-0"
})(["background-color:transparent;border:0;border-radius:0;box-sizing:border-box;color:", ";caret-color:currentColor;display:block;margin:0;padding:8px 0;", " ", " text-align:left;outline:none;width:100%;border-bottom:1px solid ", ";--inputCurrentColor:", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;&:focus,&:hover{", ";}& + ", "{transition:0.2s cubic-bezier(0.4,0,0.2,1);transition-property:transform,color;will-change:transform,color;transform-origin:0% 0%;position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none;font-size:1rem;min-height:1rem;height:auto;white-space:nowrap;display:flex;align-items:center;", " ", ";}&::placeholder{color:", ";}&:focus + ", "{", "}"], validationColor(), function (_ref4) {
  var hasStartIcon = _ref4.hasStartIcon;
  return hasStartIcon && 'padding-left: 24px;';
}, function (_ref5) {
  var hasEndIcon = _ref5.hasEndIcon;
  return hasEndIcon && 'padding-right: 24px;';
}, validationColor({
  colorVariation: 'defaultT20'
}), validationColor(), validationBorderOnInteraction, LabelText, function (_ref6) {
  var hasStartIcon = _ref6.hasStartIcon;
  return hasStartIcon && 'margin-left: 24px;';
}, function (_ref7) {
  var value = _ref7.value,
      hasPlaceholder = _ref7.hasPlaceholder;
  var hasValue = value && value.length;
  return (hasValue || hasPlaceholder) && floatingLabelCSS;
}, styles_themeUtils.nuDSColor('black', 'defaultT70'), LabelText, floatingLabelCSS);
Input.defaultProps = {
  tag: 'input',
  variant: 'paragraph2'
};
Input.propTypes = {
  hasEndIcon: index.propTypes.bool.isRequired,
  hasError: index.propTypes.bool.isRequired,
  hasStartIcon: index.propTypes.bool.isRequired,
  hasValidation: index.propTypes.bool.isRequired,
  touched: index.propTypes.bool.isRequired
};
Input.displayName = 'Input';

var TextFieldGroup = styled__default['default'].div.withConfig({
  displayName: "TextFieldGroup",
  componentId: "sc-1i0g4k7-0"
})(["font-size:1rem;max-width:100%;padding:1rem 0;position:relative;min-height:96px;"]);
TextFieldGroup.displayName = 'TextFieldGroup';

var iconStyles = function iconStyles() {
  return "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n\n  svg {\n    width: inherit;\n    height: inherit;\n    fill: currentColor;\n    cursor: default;\n  }\n";
};

var StartIcon = styled__default['default'].span.withConfig({
  displayName: "InputIcon__StartIcon",
  componentId: "nbmmz3-0"
})(["", ";left:0;"], iconStyles);
StartIcon.displayName = 'StartIcon';
var EndIcon = styled__default['default'].span.withConfig({
  displayName: "InputIcon__EndIcon",
  componentId: "nbmmz3-1"
})(["", ";right:0;"], iconStyles);
EndIcon.displayName = 'EndIcon';

function renderEndIcon(isTouched, hasEndIcon, hasValidation) {
  if (!hasEndIcon) {
    return false;
  }

  if (!hasValidation) {
    return true;
  }

  return !isTouched;
}

var TextField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      syncValidations = _ref.syncValidations,
      endIcon = _ref.endIcon,
      startIcon = _ref.startIcon,
      onBlur = _ref.onBlur,
      props = objectWithoutProperties.objectWithoutProperties(_ref, ["id", "label", "name", "syncValidations", "endIcon", "startIcon", "onBlur"]);

  var validations = FormContext.useFormValidations();

  var _useFormData = FormContext.useFormData(),
      formsValues = _useFormData.formsValues;

  var _useContext = React.useContext(formik_esm.FormikContext),
      values = _useContext.values;

  var errorMessageId = "error-".concat(name);
  var labelId = "label-".concat(name);
  var isRequired = Boolean(syncValidations.required);
  var hasStartIcon = Boolean(startIcon);
  var hasEndIcon = Boolean(endIcon);
  var hasValidation = Boolean(Object.keys(syncValidations).length);
  return /*#__PURE__*/React__default['default'].createElement(formik_esm.Field, {
    name: name,
    validate: validateField.validateField(validations, syncValidations, _extends._extends_1({}, formsValues, values))
  }, function (_ref2) {
    var field = _ref2.field,
        meta = _ref2.meta;
    var handleOnBlur = React.useCallback(function (event) {
      field.onBlur(event);
      onBlur(event);
    }, [field.onBlur, onBlur]);
    var hasError = Boolean(meta.error);
    var isTouched = Boolean(meta.touched);

    var a11yProps = _extends._extends_1({
      'aria-required': isRequired,
      'aria-invalid': hasError,
      'aria-labelledby': labelId
    }, hasError && {
      'aria-describedby': errorMessageId
    });

    return /*#__PURE__*/React__default['default'].createElement(TextFieldGroup, null, /*#__PURE__*/React__default['default'].createElement(Label, {
      htmlFor: id,
      id: labelId
    }, hasStartIcon && /*#__PURE__*/React__default['default'].createElement(StartIcon, null, startIcon), /*#__PURE__*/React__default['default'].createElement(Input, _extends._extends_1({}, a11yProps, field, props, {
      hasStartIcon: hasStartIcon,
      hasEndIcon: hasEndIcon || isTouched && hasValidation,
      hasError: hasError,
      hasValidation: hasValidation,
      hasPlaceholder: Boolean(props.placeholder),
      touched: isTouched,
      id: id,
      ref: ref,
      required: isRequired,
      onBlur: handleOnBlur
    })), /*#__PURE__*/React__default['default'].createElement(LabelText, null, /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], {
      tag: "span",
      variant: "text2"
    }, label)), renderEndIcon(isTouched, hasEndIcon, hasValidation) && /*#__PURE__*/React__default['default'].createElement(EndIcon, null, endIcon), isTouched && hasValidation && /*#__PURE__*/React__default['default'].createElement(EndIcon, null, hasError ? /*#__PURE__*/React__default['default'].createElement(components_Icon_Icon.Icon, {
      name: "x-circle",
      title: "Invalid Icon",
      color: "error"
    }) : /*#__PURE__*/React__default['default'].createElement(components_Icon_Icon.Icon, {
      name: "check-circle",
      title: "Valid Icon",
      color: "success"
    }))), /*#__PURE__*/React__default['default'].createElement(components_FieldErrorMessage_FieldErrorMessage['default'], {
      name: name,
      errorMessageId: errorMessageId
    }));
  });
});
TextField.defaultProps = {
  endIcon: undefined,
  onBlur: function onBlur() {},
  syncValidations: {},
  startIcon: undefined,
  placeholder: undefined
};
TextField.propTypes = {
  endIcon: index.propTypes.node,
  id: index.propTypes.string.isRequired,
  label: index.propTypes.string.isRequired,
  name: index.propTypes.string.isRequired,
  onBlur: index.propTypes.func,
  placeholder: index.propTypes.string,
  startIcon: index.propTypes.node,
  syncValidations: index.propTypes.objectOf(index.propTypes.any)
};

exports.default = TextField;
//# sourceMappingURL=TextField.js.map
